let onCloseCallback = null;

const ErrorModel = {
    state: {
        isOpen: false,
        error: {}
    },
    reducers: {
        setErrorPop(state, payload) {
            let temp = { ...state };
            temp.isOpen = !temp.isOpen;
            temp.error = { ...payload };
            // Store callback outside of state
            onCloseCallback = payload.onClose || null;
            return temp;
        },
        closeErrorPop(state, payload) {
            let temp = { ...state };
            temp.isOpen = false;
            temp.error = { ...payload };
            // Clear callback when closing
            onCloseCallback = null;
            return temp;
        }
    },
    effects: (dispatch) => ({
        handleErrorPop(payload) {
            this.setErrorPop(payload)
        },
        handleClose() {
            // Execute the callback if it exists
            if (onCloseCallback) {
                try {
                    onCloseCallback();
                } catch (error) {
                    console.error('Error executing onClose callback:', error);
                }
            }
            this.closeErrorPop({});
        }
    }),
};

export default ErrorModel;